import { StrictMode, useEffect } from 'react';
import { Outlet, useParams, useSearchParams } from 'react-router-dom';
import { LanguageType } from 'types/enums';
import { SurveyProvider } from './SurveyContext';

export const SurveyLayout = () => {
	const params = useParams();
	const surveyId = params.surveyId as string;
	const initialLanguage = useLanguageParams();

	if (!surveyId) {
		return <div>Survey ID is required</div>;
	}

	return (
		<StrictMode>
			<SurveyProvider surveyId={surveyId} initialLanguage={initialLanguage}>
				<Outlet />
			</SurveyProvider>
		</StrictMode>
	);
};

const useLanguageParams = () => {
	const [searchParams, setSearchParams] = useSearchParams();

	const langParam = searchParams.get('lang');
	let initialLanguage: LanguageType | undefined;

	if (langParam === 'en') {
		initialLanguage = LanguageType.English;
	} else if (langParam === 'no' || langParam === 'nb') {
		initialLanguage = LanguageType.Norwegian;
	}

	useEffect(() => {
		if (!langParam) {
			const browserLang = navigator.language || navigator.languages?.[0] || 'en';
			const languageCode = browserLang.toLowerCase().split('-')[0];
			const defaultLang =
				languageCode === 'nb' || languageCode === 'no' || languageCode === 'nn'
					? 'no'
					: 'en';

			const newParams = new URLSearchParams(searchParams);
			newParams.set('lang', defaultLang);
			setSearchParams(newParams, { replace: true });
		}
	}, [langParam, searchParams, setSearchParams]);

	return initialLanguage;
};
